import {Store} from 'redux';
import {UPDATE_GLOBAL_MESSAGE} from '~/CreateFabricGreetingCard/reducers/recipientsMessage';
import {UPDATE_SENDER} from '~/common/fabric/reducers/review/constants';
import {convertRemToPixels} from '~/common/utils';
import {Ecard} from '~/QuickEcards/types/ecard';

export const getEcardIdFromURL = () => window.location.pathname.split('/')[2];

/**
 *
 * @param element The text element whose text is being resized
 * @param initialFontSize The initial font size
 * @param units The units of the font size
 */
export const resizeText = (
  element: HTMLElement,
  initialFontSize = 16,
  units: 'rem' | 'px' = 'px'
) => {
  let fontSize = initialFontSize;
  if (units === 'rem') {
    fontSize = convertRemToPixels(initialFontSize);
  }
  element.style.fontSize = `${fontSize}px`;

  // Check if the text overflows the container
  while (element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth) {
    fontSize--; // Decrease font size
    element.style.fontSize = `${fontSize}px`;

    // Stop if font size is too small
    if (fontSize <= 8) {
      break;
    }
  }
};

export const handleRetrievedCardData = (data: Ecard, store: Store) => {
  store.dispatch({
    type: UPDATE_GLOBAL_MESSAGE,
    payload: data.event_data.options.write.text_layer_back,
  });
  store.dispatch({
    type: UPDATE_SENDER,
    payload: data.event_data.event_host_name,
  });
};
